import React from 'react';

const cart = { shopCart: null, setShopCart: () => null };
export default React.createContext(cart);
